export interface Permission {
  id: string
  key: string
  name: string
  category: string
}

export interface Role {
  id: string
  name: string
  built_in: boolean
  account_id: string | null
  editable: boolean
  permission_ids: string[]
  users_count?: number
  created_at: string
  updated_at: string
}

export interface RolesResponse {
  roles: Role[]
  permissions: Permission[]
}

export interface RoleResponse {
  role: Role
}

export interface RoleCreateParams {
  name: string
  permission_ids: string[]
}

export interface RoleUpdateParams {
  name?: string
  permission_ids?: string[]
}

export interface RoleDeleteParams {
  reassign_to?: string
}

export interface PermissionsByCategory {
  [category: string]: Permission[]
}

export function groupPermissionsByCategory(permissions: Permission[]): PermissionsByCategory {
  return permissions.reduce((acc, permission) => {
    if (!acc[permission.category]) {
      acc[permission.category] = []
    }
    acc[permission.category].push(permission)
    return acc
  }, {} as PermissionsByCategory)
}
